import { Providers } from '@/core/providers/Providers';
import { AppRoutes } from '@/core/router/routes';

import type { ReactElement } from 'react';

/**
 * App root. Composes the provider stack around the route tree. Adding
 * page-level chrome (header, sidebar) happens here once a real layout exists.
 */
export function App(): ReactElement {
  return (
    <Providers>
      <AppRoutes />
    </Providers>
  );
}
